module.exports = __webpack_public_path__ + "images/img_glyphicons-halflings.png";